'use client';

import React from 'react';
import LoadingScreen from '@/app/(app)/games/[gid]/_src/LoadingScreen';

export default function LoadingGamePage() {
  return <LoadingScreen coverHeader />;
}
